//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { EventBus } from '../../../EventBus/EventBus.js'
import { formatTime } from '../../../components/helpers.js'

import { formatTrueFalse, formatSource, getTagByKey } from './ReportMaterialsHelperFunctions.js'
import ReportMaterialsTable from './ReportMaterialsTable.vue'
import ReportMaterialsMountingEditor from './ReportMaterialsMountingEditor.vue'
import ReportRemarkImportantCheckbox from '../ReportRemarkImportantCheckbox.vue'

export default {
  components: {
    ReportMaterialsTable,
    ReportRemarkImportantCheckbox
  },
  props: {
    mountings: {
      type: Array,
      default () {
        return []
      }
    },
    demountings: {
      type: Array,
      default () {
        return []
      }
    },
    debits: {
      type: Array,
      default () {
        return []
      }
    },
    consumptions: {
      type: Array,
      default () {
        return []
      }
    },
    reportId: {
      type: Number,
      default: 0
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    checking: {
      type: Boolean,
      default: false
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    },
    tags: {
      type: Array,
      default () {
        return []
      }
    },
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      updateSegmentHandler: null,

      selectedItemsLength: 0,
      columns: [
        {
          name: 'toolName',
          label: 'Название',
          align: 'left',
          field: 'toolName',
          sortable: true,
          defaultWidth: 200
        },
        {
          name: 'toolKey',
          label: 'ID номенклатурной позиции в 1С',
          align: 'left',
          field: 'toolKey',
          sortable: true,
          defaultWidth: 200
        },
        {
          name: 'amount',
          label: 'Кол-во',
          align: 'left',
          field: 'amount',
          sortable: true
        },
        {
          name: 'unit',
          label: 'Ед. изм.',
          align: 'left',
          field: 'unit',
          sortable: true
        },
        {
          name: 'sn',
          label: 'Серийный номер',
          align: 'left',
          field: 'sn',
          sortable: true
        },
        {
          name: 'sourceTable',
          label: 'Источник',
          align: 'left',
          field: 'sourceTable',
          sortable: true,
          format: formatSource
        },
        {
          name: 'tag',
          label: 'Тег',
          align: 'left',
          field: 'tag',
          format: tag => getTagByKey(tag, this.tags),
          sortable: true,
          defaultWidth: 100
        },
        {
          name: 'noted',
          label: 'Результат проверки',
          align: 'left',
          field: 'noted',
          sortable: true
        },
        {
          name: 'note',
          label: 'Замечание аналитика',
          align: 'left',
          field: 'note',
          sortable: true
        },
        {
          name: 'changed',
          label: 'Изменено',
          align: 'left',
          field: 'changed',
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 100
        },
        {
          name: 'time',
          label: 'Дата/время',
          align: 'left',
          field: 'time',
          sortable: true,
          format: formatTime,
          defaultWidth: 150
        },
        {
          name: 'user',
          label: 'Сотрудник',
          align: 'left',
          field: 'user',
          sortable: true,
          defaultWidth: 200
        }
      ]
    }
  },
  created: function () {
    this.updateSegmentHandler = (data) => {
      if (this.report.key !== data.reportKey) {
        return
      }

      const selectedSegment = data.segment

      if (data.operation.type === 'delete') {
        const row = this.mountings.find(mounting => mounting.recId === selectedSegment.mountingId)
        this.onDeleteMounting(row)
      } else {
        if (selectedSegment.mountingId) {
          const row = this.mountings.find(mounting => mounting.recId === selectedSegment.mountingId)
          if (row.sourceTable !== 'debit' && row.sourceTable !== 'consumption') {
            this.onEditMounting(row)
          } else {
            // обрабатывается в списании и расходе
          }
        } else {
          this.onAddOperationMounting('mounting', null, selectedSegment)
        }
      }
    }

    EventBus.$on('mounting-segment', this.updateSegmentHandler)
  },
  beforeDestroy: function () {
    EventBus.$off('mounting-segment', this.updateSegmentHandler)
  },
  methods: {
    onSelectedItems: function (selectedItemsLength) {
      this.selectedItemsLength = selectedItemsLength
    },
    onAddMounting: function (operation, selectedSegment, isReplacementDemounting, sourceTable) {
      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        persistent: true,
        noWrap: true,
        contentWidth: 560,
        contentComponent: ReportMaterialsMountingEditor,
        contentProps: {
          record: null,
          isEdit: false,
          operation: operation,
          // ===
          isReplacementDemounting: isReplacementDemounting,
          sourceTableInput: sourceTable,
          selectedSegment: selectedSegment,
          serviceObject: this.serviceObject,
          // ===
          debits: this.debits,
          consumptions: this.consumptions,
          mountings: this.mountings,
          demountings: this.demountings,
          tags: this.tags,
          report: this.report,
          reportActionsAccess: this.reportActionsAccess
        },
        componentHandlers: {
          save: (mounting) => {
            dialog.hide()
            this.onSaveAddMounting(mounting, selectedSegment)
          },
          close: () => {
            dialog.hide()
          }
        }
      })
    },
    onAddRemark: function () {
      if (this.report.mountingRemarks.length === 0) {
        this.report.mountingRemarks.push({
          active: true,
          code: 'mountingRemarks',
          comment: null,
          important: false
        })
      } else {
        this.report.mountingRemarks[0].active = true
      }
    },
    onDeleteRemark: function () {
      if (this.report.mountingRemarks.length !== 0) {
        this.report.mountingRemarks[0].active = false
      }
    },
    onApproveSelectedMountings: function () {
      this.$refs.reportMaterialsTable.$refs.reportMaterialsTableDispatcher.approveSelectedItems()
    },
    onDeleteMounting: function (row) {
      const index = this.mountings.indexOf(row)
      this.mountings.splice(index, 1) // TODO delete mounting

      const indexDebit = this.debits.findIndex(debit => debit.mountingId === row.recId)
      if (indexDebit !== -1) {
        if (row.isSegment) {
          this.debits.splice(indexDebit, 1) // TODO delete debit
        } else {
          this.debits[indexDebit].mountingId = null
        }
      }

      const indexConsumption = this.consumptions.findIndex(consumption => consumption.mountingId === row.recId)
      if (indexConsumption !== -1) {
        if (row.isSegment) {
          this.consumptions.splice(indexConsumption, 1) // TODO delete consumption
        } else {
          this.consumptions[indexConsumption].mountingId = null
        }
      }

      if (row.demountingId) {
        const indexDemounting = this.demountings.findIndex(demounting => demounting.recId === row.demountingId)
        this.demountings.splice(indexDemounting, 1) // TODO delete demounting
      }
    },
    onEditMounting: function (row) {
      const consumption = this.consumptions.find(consumption => consumption.mountingId === row.recId)
      const debit = this.debits.find(debit => debit.mountingId === row.recId)

      const hasLink = !!(consumption || debit)
      if (hasLink) {
        this.$q.notify({
          type: 'negative',
          message: 'Редактирование запрещено. Редактируйте списание/расход, которое ссылается на данный монтаж.',
          progress: true,
          timeout: 8000
        })

        return
      }

      const index = this.mountings.indexOf(row)
      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        persistent: true,
        noWrap: true,
        contentWidth: 560,
        contentComponent: ReportMaterialsMountingEditor,
        contentProps: {
          record: row,
          isEdit: true,
          operation: null,
          // ===
          serviceObject: this.serviceObject,
          // ===
          debits: this.debits,
          consumptions: this.consumptions,
          mountings: this.mountings,
          demountings: this.demountings,
          tags: this.tags,
          report: this.report,
          reportActionsAccess: this.reportActionsAccess
        },
        componentHandlers: {
          save: (mounting) => {
            dialog.hide()
            this.onSaveEditMounting(mounting, index)
          },
          close: () => {
            dialog.hide()
          }
        }
      })
    },
    onSaveAddMounting: function (mounting, selectedSegment) {
      mounting = JSON.parse(JSON.stringify(mounting)) // TODO new mounting

      if (selectedSegment) {
        mounting.isSegment = true
      }

      mounting.recId = new Date().getTime()
      if (selectedSegment) {
        selectedSegment.mountingId = mounting.recId
      }
      this.mountings.push(mounting) // TODO add mounting

      this.changeOtherRecords(mounting, false)
    },
    onSaveEditMounting: function (mounting, index) {
      const originalInitial = this.mountings[index] ? this.mountings[index]._initial : undefined
      mounting = JSON.parse(JSON.stringify(mounting)) // TODO new mounting
      if (originalInitial !== undefined) {
        Object.defineProperty(mounting, '_initial', {
          value: originalInitial,
          writable: false,
          enumerable: false,
          configurable: true
        })
      }
      this.mountings.splice(index, 1, mounting) // TODO update mounting

      this.changeOtherRecords(mounting, true)
    },
    changeOtherRecords: function (mounting, isEdit) {
      if (isEdit && mounting.demountingId) {
        const demounting = this.demountings.find(demounting => demounting.recId === mounting.demountingId)
        if (demounting) {
          demounting.toolKey = mounting.toolKey
          demounting.toolName = mounting.toolName
          demounting.amount = -mounting.amount
          demounting.unit = mounting.unit
          demounting.sn = mounting.sn
          demounting.tag = mounting.tag
        }
      }

      if (mounting.debitId) {
        const debit = this.debits.find(debit => debit.recId === mounting.debitId)
        if (debit) {
          debit.mountingId = mounting.recId
        }
      }

      if (mounting.consumptionId) {
        const consumption = this.consumptions.find(consumption => consumption.recId === mounting.consumptionId)
        if (consumption) {
          consumption.mountingId = mounting.recId
        }
      }

      if (mounting.demountingId && !isEdit) {
        const indexDemounting = this.demountings.findIndex(demounting => demounting.recId === mounting.demountingId)
        if (indexDemounting !== -1) {
          const demounting = JSON.parse(JSON.stringify(this.demountings[indexDemounting])) // TODO new demounting
          demounting.amount = -mounting.amount
          demounting.serviceObjectKey = this.serviceObject.key
          demounting.serviceObjectName = this.serviceObject.name
          demounting.recId = new Date().getTime()
          demounting.reports = null
          mounting.demountingId = demounting.recId
          this.demountings.push(demounting) // TODO add demounting
        }
      }
    },
    onAddOperationMounting: function (operation, demountingId, selectedSegment) {
      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        persistent: true,
        noWrap: true,
        contentWidth: 560,
        contentComponent: ReportMaterialsMountingEditor,
        contentProps: {
          record: null,
          isEdit: false,
          operation: operation,
          // ===
          selectedSegment: selectedSegment,
          // ===
          debits: this.debits,
          consumptions: this.consumptions,
          mountings: this.mountings,
          demountings: this.demountings,
          tags: this.tags,
          report: this.report,
          reportActionsAccess: this.reportActionsAccess
        },
        componentHandlers: {
          save: (mounting) => {
            dialog.hide()
            this.onSaveOperationMountingTable(mounting, operation, demountingId, selectedSegment)
          },
          close: () => {
            if (operation === 'replacement') {
              this.$parent.$parent.$parent.$parent.$refs.demountings.onDeleteDemounting(demountingId)
            }
            dialog.hide()
          }
        }
      })
    },
    onAddOperationReplacement: function () {
      this.$parent.$parent.$parent.$parent.$refs.demountings.onAddDemounting('replacement')
    },
    onSaveOperationMountingTable: function (mounting, operation, demountingId, selectedSegment) {
      if (mounting.sourceTable === 'debit') {
        this.$parent.$parent.$parent.$parent.$refs.debits.onAddDebit(operation, demountingId, selectedSegment)
      } else if (mounting.sourceTable === 'consumption') {
        this.$parent.$parent.$parent.$parent.$refs.consumptions.onAddConsumption(operation, demountingId, selectedSegment)
      } else if (mounting.sourceTable === 'demounting') {
        let isReplacementDemounting = false
        if (!selectedSegment) {
          isReplacementDemounting = true
        }
        this.onAddMounting(null, selectedSegment, isReplacementDemounting, 'demounting')
      }
    }
  }
}

